import { render, staticRenderFns } from "./LandingBirthdayIT.vue?vue&type=template&id=eea546f0"
import script from "./LandingBirthdayIT.vue?vue&type=script&lang=js"
export * from "./LandingBirthdayIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports